<template>
  <v-card class="calculatedValues">
    <v-card-title> Calculation values </v-card-title>
    <v-card-text>
    <v-simple-table dense class="pa-4">
      <template v-slot:default>
        <tbody>
          <tr v-for="item in values" :key="item.FieldName">
            <td class="font-weight-medium text-body-1">{{ item.FieldName }}</td>
            <td class="text-body-1">{{ item.Value }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    </v-card-text>
    <v-card-actions>
          <v-spacer></v-spacer>
      <v-btn color="primary" depressed @click="onClose">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'CalculatedValues',
  components: {},
  props: {
    values: Array,
  },
  data() {
    return {};
  },
  methods: {
    onClose() {
      this.$emit('closeResults');
    },
  },
};
</script>

<style scoped>
  
</style>
